<template>
  <component :is="'style'">
    :root {
    --speed: target {{ speed }}s;
    }
  </component>
</template>

<script>
import {mapGetters} from "vuex";

export default {

  computed: {

    speed: function (){
      let level =  stateTagApp.commands.getLevel();
      return level.speed;
    }
  }
}
</script>

<style>
.target.speed{
  animation: var(--speed);
  -moz-animation: var(--speed);
  -webkit-animation: var(--speed);
}
</style>